/**
 * @author: subhasish.ghosh@zoom.us
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import OperationsThemeProvider from "@wrapper/OperationsThemeProvider";
import { isLocalEnvironment } from "@utils/utils";
import CSRFTokenProvider from "@wrapper/CSRFTokenProvider";
import store from "@redux/actions/store";
import { Provider } from "react-redux";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  isLocalEnvironment() ? (
    <React.StrictMode>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          {/* <CSRFTokenProvider> */}
          <OperationsThemeProvider>
            <App />
          </OperationsThemeProvider>
          {/* </CSRFTokenProvider> */}
        </QueryClientProvider>
      </Provider>
    </React.StrictMode>
  ) : (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        {/* <CSRFTokenProvider> */}
        <OperationsThemeProvider>
          <App />
        </OperationsThemeProvider>
        {/* </CSRFTokenProvider> */}
      </QueryClientProvider>
    </Provider>
  )
);
